import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { FlameIcon, ArrowLeftIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '../components/Button';
export function ApplyPage() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    path: '',
    why: ''
  });
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Application submitted:', formData);
    // Handle form submission
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };
  return <div className="min-h-screen bg-[var(--forge-black)] py-20 px-6" data-id="element-173">
      <div className="max-w-3xl mx-auto" data-id="element-174">
        <Link to="/" className="inline-flex items-center gap-2 text-[var(--forge-gray)] hover:text-[var(--forge-lava)] transition-colors mb-12" data-id="element-175">
          <ArrowLeftIcon className="w-5 h-5" data-id="element-176" />
          Back to home
        </Link>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} data-id="element-177">
          <div className="flex items-center gap-4 mb-8" data-id="element-178">
            <FlameIcon className="w-12 h-12 text-[var(--forge-lava)]" data-id="element-179" />
            <h1 className="text-5xl md:text-6xl font-black tracking-tighter" data-id="element-180">
              APPLY TO{' '}
              <span className="text-[var(--forge-lava)]" data-id="element-181">THE FORGE</span>
            </h1>
          </div>

          <div className="bg-[var(--forge-charcoal)] border-2 border-[var(--forge-lava)]/30 p-8 mb-8" data-id="element-182">
            <p className="text-lg text-[var(--forge-white)] leading-relaxed mb-4" data-id="element-183">
              This is not a job application. This is a selection process.
            </p>
            <p className="text-[var(--forge-gray)] leading-relaxed" data-id="element-184">
              We are looking for individuals who are ready to be challenged, who
              embrace pressure, and who are committed to becoming elite
              performers. If that's you, complete the form below.
            </p>
          </div>

          <form onSubmit={handleSubmit} className="bg-[var(--forge-steel)] border border-[var(--forge-zinc)]/30 p-8 space-y-6" data-id="element-185">
            <div data-id="element-186">
              <label htmlFor="name" className="block text-sm font-bold text-[var(--forge-white)] mb-2 tracking-wide" data-id="element-187">
                FULL NAME *
              </label>
              <input type="text" id="name" name="name" required value={formData.name} onChange={handleChange} className="w-full bg-[var(--forge-charcoal)] border border-[var(--forge-zinc)] text-[var(--forge-white)] px-4 py-3 focus:outline-none focus:border-[var(--forge-lava)] transition-colors" placeholder="Enter your full name" data-id="element-188" />
            </div>

            <div data-id="element-189">
              <label htmlFor="email" className="block text-sm font-bold text-[var(--forge-white)] mb-2 tracking-wide" data-id="element-190">
                EMAIL *
              </label>
              <input type="email" id="email" name="email" required value={formData.email} onChange={handleChange} className="w-full bg-[var(--forge-charcoal)] border border-[var(--forge-zinc)] text-[var(--forge-white)] px-4 py-3 focus:outline-none focus:border-[var(--forge-lava)] transition-colors" placeholder="your.email@example.com" data-id="element-191" />
            </div>

            <div data-id="element-192">
              <label htmlFor="phone" className="block text-sm font-bold text-[var(--forge-white)] mb-2 tracking-wide" data-id="element-193">
                PHONE *
              </label>
              <input type="tel" id="phone" name="phone" required value={formData.phone} onChange={handleChange} className="w-full bg-[var(--forge-charcoal)] border border-[var(--forge-zinc)] text-[var(--forge-white)] px-4 py-3 focus:outline-none focus:border-[var(--forge-lava)] transition-colors" placeholder="(555) 123-4567" data-id="element-194" />
            </div>

            <div data-id="element-195">
              <label htmlFor="path" className="block text-sm font-bold text-[var(--forge-white)] mb-2 tracking-wide" data-id="element-196">
                WHICH PATH FITS YOU? *
              </label>
              <select id="path" name="path" required value={formData.path} onChange={handleChange} className="w-full bg-[var(--forge-charcoal)] border border-[var(--forge-zinc)] text-[var(--forge-white)] px-4 py-3 focus:outline-none focus:border-[var(--forge-lava)] transition-colors" data-id="element-197">
                <option value="" data-id="element-198">Select a path</option>
                <option value="rookie" data-id="element-199">Rookie Path</option>
                <option value="operator" data-id="element-200">Operator Path</option>
                <option value="leader" data-id="element-201">Forge Leader Path</option>
              </select>
            </div>

            <div data-id="element-202">
              <label htmlFor="why" className="block text-sm font-bold text-[var(--forge-white)] mb-2 tracking-wide" data-id="element-203">
                WHY DO YOU WANT TO ENTER THE FORGE? *
              </label>
              <textarea id="why" name="why" required value={formData.why} onChange={handleChange} rows={6} className="w-full bg-[var(--forge-charcoal)] border border-[var(--forge-zinc)] text-[var(--forge-white)] px-4 py-3 focus:outline-none focus:border-[var(--forge-lava)] transition-colors resize-none" placeholder="Tell us about your drive, your goals, and why you're ready for this..." data-id="element-204" />
            </div>

            <div className="pt-4" data-id="element-205">
              <Button type="submit" size="lg" className="w-full" data-id="element-206">
                SUBMIT APPLICATION
              </Button>
              <p className="text-sm text-[var(--forge-gray)] text-center mt-4 italic" data-id="element-207">
                By submitting, you acknowledge this is a serious commitment to
                your growth.
              </p>
            </div>
          </form>
        </motion.div>
      </div>
    </div>;
}